export default {
  showPreview: 'Zobraziť náhľad signálu',
  hidePreview: 'Skryť náhľad signálu',
};
